import React from "react";
import { Link } from "react-router-dom";

import kitchenGardenImage from "../assets/images/kitchen-gardening.jpg";

const KitchenGardening = () => {

  return (
    <>

      <section
        className="kitchen-hero"
        style={{
          backgroundImage: `url(${kitchenGardenImage})`
        }}
      >

        <div className="kitchen-overlay">

          <div className="container text-center">

            <h1>
              Kitchen Gardening in Dubai
            </h1>

            <p>
              Grow fresh herbs, vegetables, and plants right at home.
            </p>

          </div>

        </div>

      </section>


      <section className="kitchen-content">

        <div className="container">

          <div className="kitchen-intro">

            <span>KITCHEN GARDENING</span>

            <h2>
              Fresh, Green & Productive Kitchen Gardens
            </h2>

            <p>
              We design and create practical kitchen gardens that allow
              homes, villas, and other spaces to grow fresh herbs,
              vegetables, and plants in a convenient and sustainable way.
            </p>

          </div>


          <div className="row">

            <div className="col-lg-4 col-md-6">

              <div className="kitchen-card">

                <i className="fas fa-leaf"></i>

                <h3>
                  Herb Gardens
                </h3>

                <p>
                  Grow fresh herbs and useful plants conveniently
                  within your own garden.
                </p>

              </div>

            </div>


            <div className="col-lg-4 col-md-6">

              <div className="kitchen-card">

                <i className="fas fa-seedling"></i>

                <h3>
                  Vegetable Gardens
                </h3>

                <p>
                  Practical vegetable growing solutions designed
                  for homes and outdoor spaces.
                </p>

              </div>

            </div>


            <div className="col-lg-4 col-md-6">

              <div className="kitchen-card">

                <i className="fas fa-spa"></i>

                <h3>
                  Garden Setup & Care
                </h3>

                <p>
                  Complete setup and ongoing care to help your
                  kitchen garden thrive.
                </p>

              </div>

            </div>

          </div>


          <div className="kitchen-cta">

            <h2>
              Start Your Own Kitchen Garden
            </h2>

            <p>
              Let our experts design a practical green space for you.
            </p>

            <Link
              to="/contact"
              className="kitchen-btn"
            >
              GET STARTED
            </Link>

          </div>

        </div>

      </section>


      <style>
        {`

        .kitchen-hero {
          min-height: 520px;

          background-size: cover;
          background-position: center;

          display: flex;
          align-items: center;
        }

        .kitchen-overlay {
          width: 100%;

          padding: 100px 20px;

          background: rgba(0,0,0,.48);
        }

        .kitchen-hero h1 {
          color: #fff;

          font-size: 52px;

          font-weight: 700;
        }

        .kitchen-hero p {
          color: #fff;

          font-size: 18px;
        }


        .kitchen-content {
          padding: 90px 20px;
        }

        .kitchen-intro {
          max-width: 850px;

          margin: 0 auto 60px;

          text-align: center;
        }

        .kitchen-intro span {
          color: #4c8b3c;

          font-size: 13px;

          font-weight: 700;

          letter-spacing: 3px;
        }

        .kitchen-intro h2 {
          margin: 12px 0 20px;

          font-size: 40px;

          font-weight: 700;
        }

        .kitchen-intro p {
          color: #666;

          line-height: 1.8;
        }


        .kitchen-card {
          height: 100%;

          margin-bottom: 30px;

          padding: 35px 25px;

          text-align: center;

          background: #f7faf6;

          border-radius: 10px;

          transition: .3s;
        }

        .kitchen-card:hover {
          transform: translateY(-7px);

          box-shadow:
            0 12px 30px rgba(0,0,0,.1);
        }

        .kitchen-card i {
          color: #4c8b3c;

          font-size: 35px;

          margin-bottom: 20px;
        }

        .kitchen-card h3 {
          font-size: 21px;
        }

        .kitchen-card p {
          color: #666;

          line-height: 1.7;
        }


        .kitchen-cta {
          margin-top: 40px;

          padding: 55px 20px;

          text-align: center;

          border-radius: 12px;

          background: #4c8b3c;
        }

        .kitchen-cta h2,
        .kitchen-cta p {
          color: #fff;
        }

        .kitchen-btn {
          display: inline-block;

          margin-top: 10px;

          padding: 13px 28px;

          color: #4c8b3c;

          background: #fff;

          border-radius: 4px;

          font-weight: 700;

          text-decoration: none;
        }


        @media(max-width:767px) {

          .kitchen-hero {
            min-height: 420px;
          }

          .kitchen-hero h1 {
            font-size: 34px;
          }

          .kitchen-intro h2 {
            font-size: 30px;
          }

        }

        `}
      </style>

    </>
  );
};

export default KitchenGardening;
